export default "/images/LuisCarqueja.jpg?60ee6bd010acaaa59a8c118a87ff460c";